import { isSameDay } from 'date-fns';
import { useMemo } from 'react';
import type { MessageGroup, VirtualChatRow } from '../../../types';

type P = {
  hasNextPage: boolean;
  messageGroups: MessageGroup[];
};

const needsDayDivider = (previous: Date | undefined, current: Date) => !previous || !isSameDay(previous, current);

export const useVirtualChatRows = ({ hasNextPage, messageGroups }: P) =>
  useMemo(() => {
    const rows: VirtualChatRow[] = [];
    let lastMessageDate: Date | undefined;

    for (const group of messageGroups) {
      for (const [index, message] of group.messages.entries()) {
        if (needsDayDivider(lastMessageDate, message.createdAt)) {
          const isOldestLoadedDay = lastMessageDate === undefined;

          if (!isOldestLoadedDay || !hasNextPage) {
            rows.push({ date: message.createdAt, kind: 'day-divider' });
          }
        }

        rows.push({
          direction: group.direction,
          group: {
            author: group.author,
            index,
            length: group.messages.length,
          },
          kind: 'message',
          message,
        });

        lastMessageDate = message.createdAt;
      }
    }

    return rows;
  }, [hasNextPage, messageGroups]);
